module.exports = __webpack_public_path__ + "img/sign-in-button.1ef82116.svg";